import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { IndustryModal } from './IndustryModal';
import { useAnalytics, ANALYTICS_EVENTS } from '@/hooks/useAnalytics';

const industries = [
  'Product Management',
  'Software Development',
  'Human Resources',
  'Finance & Accounting',
  'Project Management',
  'Sales & Business Development',
  'Marketing & Communications',
  'Data Science & Analytics',
  'Design (UI/UX)',
  'Operations Management',
  'Customer Success',
  'Strategy & Consulting',
  'Research & Development',
  'Other'
];

export const IndustrySelection = () => {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();
  const [selectedIndustry, setSelectedIndustry] = useState<string | null>(null);
  const [otherIndustry, setOtherIndustry] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<'other' | 'coming-soon'>('other');

  const handleIndustrySelect = (industry: string) => {
    console.log('Industry selected:', industry);
    setSelectedIndustry(industry);
    
    // Track the industry selection
    trackEvent(ANALYTICS_EVENTS.INDUSTRY_SELECTED, {
      industry: industry === 'Other' ? otherIndustry || 'Other' : industry,
      is_available: industry === 'Product Management'
    });
    
    // Track that user attempted to get a score
    trackEvent(ANALYTICS_EVENTS.SCORE_ATTEMPTED, {
      industry: industry === 'Other' ? otherIndustry || 'Other' : industry,
      success: industry === 'Product Management'
    });
    
    if (industry === 'Product Management') {
      navigate('/assessment/product-management');
    } else if (industry === 'Other') {
      setModalType('other');
      setShowModal(true);
    } else {
      setModalType('coming-soon');
      setShowModal(true);
    }
  };

  return (
    <div className="container-content py-16">
      <div className="text-center mb-12">
        <h2>Select Your Industry</h2>
        <p className="text-text-secondary mt-4">
          Choose the industry that best matches your professional focus
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {industries.map((industry) => (
          <Card
            key={industry}
            className={cn(
              "p-6 cursor-pointer industry-card",
              selectedIndustry === industry
                ? "border-primary border-2"
                : "border-border hover:border-primary/50 border-2",
              industry === 'Product Management' && "bg-primary/5"
            )}
            onClick={() => handleIndustrySelect(industry)}
          >
            <div className="flex flex-col h-full">
              <h3 className="text-lg font-medium mb-2">{industry}</h3>
              {industry === 'Product Management' && (
                <span className="text-sm text-primary">Available Now</span>
              )}
              {industry === 'Other' && selectedIndustry === 'Other' && (
                <Input
                  className="mt-2"
                  placeholder="Specify your industry"
                  value={otherIndustry}
                  onChange={(e) => setOtherIndustry(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              )}
            </div>
          </Card>
        ))}
      </div>

      <IndustryModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        type={modalType}
        selectedIndustry={selectedIndustry || ''}
      />
    </div>
  );
};